import styled from '../../../styles/theme';
import { CharacteristicsStyled } from '../CharacteristicsStyled';
import { rem } from 'polished';

export const CharacteristicsStyledDS = styled(CharacteristicsStyled)`
    .environmentalWrapper {
        background-color: ${({ theme }) => theme.colors.grey4};
    }
    .technicalTitle {
        font-style: normal;
        font-family: ${({ theme }) => theme.fonts.fontBase};
        font-weight: ${({ theme }) => theme.fontWeights.textRegular};
        font-size: ${rem(28)};
    }
    .technicalSubtitle {
        font-weight: bold;
    }
    .techBlock {
        .imageWrapper-gearbox {
            svg {
                path {
                    fill: ${({ theme }) => theme.colors.black1};
                }
            }
        }
        .imageWrapper-fuel {
            svg {
                path {
                    stroke: ${({ theme }) => theme.colors.black1};
                }
            }
        }
        .techWrapper {
            margin-left: ${rem(9)};
            color: ${({ theme }) => theme.colors.black1};
            .techLabel {
                text-transform: unset;
            }
            span {
                color: ${({ theme }) => theme.colors.black1};
            }
        }
    }

    .environmentalWrapper div:first-of-type .environmentalBlock {
        border-right: none;
        padding-right: 1rem;

        @media (min-width: ${rem(992)}) {
            border-right: solid 2px ${({ theme }) => theme.colors.black4};
        }
    }

    .environmentalBlock {
        .environmentalItem span {
            color: ${({ theme }) => theme.colors.black1};
        }
    }
    .Collapsible {
        &__trigger {
            padding-left: 0;
        }
        .featureTitleWide {
            border-top: none;
        }
    }
    .technicalFeaturesModule {
        .featureList {
            color: ${({ theme }) => theme.colors.black1};
        }
    }
    .legalText {
        color: ${({ theme }) => theme.colors.grey5};
        a {
            color: ${({ theme }) => theme.colors.secondary};
        }
    }
    > div {
        > div:nth-last-child(2) {
            border-bottom: none;
        }
    }

    .technicalDetails {
        font-style: normal;
        font-family: ${({ theme }) => theme.fonts.fontBase};
    }

    .featureList {
        .featureInfo {
            text-align: left;
        }
    }
`;
